import { isArrayWithContent } from 'utils/arrays';

export function filterDisallowed(entity, disallowed) {
	return Object.keys(entity)
		.filter(key => !disallowed.includes(key))
		.reduce((obj, key) => {
			const newObj = obj;
			newObj[key] = entity[key];
			return obj;
		}, {});
}

export function hasRichTextContent(text) {
	return !!text && text !== '<p><br></p>' && text !== '<p>&nbsp;</p>' && text !== '<p></p>';
}

function s4() {
	return Math.floor((1 + Math.random()) * 0x10000)
		.toString(16)
		.substring(1);
}

export function guid() {
	// does not follow RFC4122
	return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
}

export function numberUid() {
	return parseFloat(`${s4()}${s4()}${s4()}`, 10);
}

export function uuid() {
	function chr4() {
		return Math.random()
			.toString(16)
			.slice(-4);
	}
	return `${chr4()}${chr4()}-${chr4()}-${chr4()}-${chr4()}`;
}

export function randomNumber(floor = 0, ceil = 100) {
	return Math.floor(Math.random() * ceil) + floor;
}

/**
 * @function splitByHtml
 * @param {String} s with richMarkup e.g <div><p>Hello</p><p>World</p></div>
 * @returns {Array} ["Hello", "World"]
 */
export function splitByHtml(s) {
	const regex = /<[^>]*>/gi;
	const nonWhitespaceRegex = /\S/;
	return s
		.replace(regex, '©')
		.split('©')
		.filter(s => nonWhitespaceRegex.test(s));
}

/**
 * @function createStringEllipse
 * @param {String} str
 * @param {Number} allowedMaxLength
 * @returns {String}
 */
export function createStringEllipse(str, allowedMaxLength = 20) {
	if (!str) {
		return '';
	}

	if (str.length > allowedMaxLength) {
		return `${str.substring(0, allowedMaxLength)}...`;
	}

	return str;
}

/**
 * @function createRichMarkupElipse
 * @param {String} richMarkupDescription
 * @returns {String}
 */
export const createRichMarkupElipse = (richMarkupDescription, htmlElementIndex = 0, allowedMaxLength = 30) => {
	if (!richMarkupDescription) {
		return '';
	}

	const splittedByHtmlTag = splitByHtml(richMarkupDescription);

	if (isArrayWithContent(splittedByHtmlTag)) {
		return createStringEllipse(splittedByHtmlTag[htmlElementIndex] || splittedByHtmlTag[0], allowedMaxLength);
	}

	return '';
};

/**
 * @function removeSpecialCharactersFromString
 * @param {String} string
 * @returns {String} stripped of everything that is not a letter or a number
 */
export const removeSpecialCharactersFromString = string => string.replace(/[^a-zA-Z0-9 ]/g, '');
